import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/apiClient";

const SiteCtx = createContext(null);
export const useSite = () => useContext(SiteCtx);

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/public/site").then((r) => setSite(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);
  return <SiteCtx.Provider value={{ site, loading }}>{children}</SiteCtx.Provider>;
}
